import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-flex-carousel',
    templateUrl: './block-flex-carousel.component.html',
})

export class BlockFlexCarouselComponent extends BlockAbstractComponent implements OnInit {

    slideConfig = {
        loop: true,
        navigation: {
            nextEl: '.flex-carousel-controls__next',
            prevEl: '.flex-carousel-controls__prev'
        },
        pagination: {
            bulletActiveClass: 'flex-carousel-controls__indicator--active',
            bulletClass: 'flex-carousel-controls__indicator',
            clickable: true,
            el: '.flex-carousel-controls__indicator-wrapper',
        },
        slideClass: 'flex-carousel-slider__item',
        wrapperClass: 'flex-carousel-slider__container'
    };

}
